import React, { FC, useMemo } from 'react';
import { MUIFieldProps } from '../../../../../lib/types/types';
import { DatePicker } from '@mui/x-date-pickers-pro';
import dayjs, { Dayjs } from 'dayjs';

const MUIDateField: FC<MUIFieldProps> = (props) => {
	const { label, fieldValue, updateFieldValue, isDisabled, error, errorMessage, ...restProps } = props;

	const initialValue = useMemo(() => {
		return dayjs(fieldValue, 'YYYY-MM-DD');
	}, [fieldValue]);

	const handleOnChange = (value: Dayjs | null) => {
		const strapiValue = value ? value.format('YYYY-MM-DD') : null;
		const e = { target: { value: strapiValue } };
		updateFieldValue(e as React.ChangeEvent<HTMLInputElement>);
	};

	return (
		<DatePicker
			label={label}
			format={'DD.MM.YYYY'}
			value={initialValue}
			onChange={handleOnChange}
			disabled={isDisabled}
			slotProps={{
				textField: {
					error: error,
					helperText: errorMessage,
				},
			}}
			sx={{ width: '100%' }}
			{...restProps}
		/>
	);
};
export default MUIDateField;
